<template>
    <div class="vc-cart-header">
        <template v-if="itemAdded">
            <span class="vc-cart-header__title">ITEM ADDED</span>
        </template>
        <template v-else>
            <span class="vc-cart-header__title">SHOPPING CART</span>
            <cart-controls></cart-controls>
        </template>
    </div>
</template>

<script>
    import Configure from '../../mixins/configure'
    import CartControls from './cart-controls.vue'

    export default {
        name: "cart-header",
        props: {
            itemAdded: {
                type: Boolean,
                default: false,
            }
        },
        mixins: [Configure],
        components: {
            CartControls
        }
    }
</script>

<style lang="scss" scoped>
    $padding: 15px;

    .vc-cart-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        &__title {
            font-size: 20px;
            font-weight: 600;
            color: var(--menu-item-active-text-color);
            text-transform: uppercase;
        }
    }
</style>